import "current-script-polyfill"

// Vue app initialization
import Vue                       from "vue"
import App                       from "./App.vue"
import store                     from "./store"
import router                    from "./router"
import ExpiviReady               from "./mixins/ExpiviReady"
import ProgressBar               from "./components/ProgressBar"
import ColorSelector             from "./components/configurator/general/ColorSelector"
import ScaleSelector             from "./components/configurator/general/ScaleSelector"
import HeightTransition          from "./components/transitions/HeightTransition"
import RouterViewSlideTransition from "./components/transitions/RouterViewSlideTransition"
import Modal                     from "./components/ui/Modal"
import Uniqid                    from "./mixins/Uniqid"
import DataLayer                 from "./mixins/DataLayer"
import WebFont                   from "webfontloader"

WebFont.load({
    google: {
        families: ['Abel', 'Crete Round', 'Hind Madurai', 'Montserrat', 'Old Standard TT', 'Playfair Display', 'Roboto', 'Suranna']
    }
})

Vue.mixin(ExpiviReady)
Vue.mixin(Uniqid)
Vue.mixin(DataLayer)
Vue.component('progress-bar', ProgressBar)
Vue.component('color-selector', ColorSelector)
Vue.component('scale-selector', ScaleSelector)
Vue.component('ui-modal', Modal)
Vue.component('height-transition', HeightTransition)
Vue.component('router-view-slide-transition', RouterViewSlideTransition)

new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#configurator-app')
